document.addEventListener("DOMContentLoaded", () => {
  /* ================= Elements ================= */
  const uploadInput = document.getElementById("virtual-tryon-upload");
  const previewImg = document.getElementById("virtual-tryon-preview");
  const placeholder = document.getElementById("virtual-tryon-placeholder");
  const tryOnBtn = document.getElementById("virtual-tryon-btn");
  const uploadBox = document.querySelector(".virtual-tryon-upload-box");
  const removeBtn = document.getElementById("virtual-tryon-remove");
  const downloadBtn = document.getElementById("virtual-tryon-download");
  const overlay = document.getElementById("virtual-tryon-overlay");
  const overlayImg = document.getElementById("virtual-tryon-overlay-img");
  const overlayClose = document.getElementById("virtual-tryon-overlay-close");

  if (!uploadInput || !previewImg || !tryOnBtn || !uploadBox || !placeholder) {
    console.error("Virtual Try-On: DOM elements missing");
    return;
  }

  /* Move overlay to <body> to escape Shopify stacking context */
  if (overlay) {
    document.body.appendChild(overlay);
  }

  /* ================= State ================= */
  const state = {
    file: null,
    requestId: null,
    resultUrl: null,
    status: "idle",
    isRequestInFlight: false
  };

  /* ================= Initial State ================= */
  tryOnBtn.disabled = true;
  previewImg.classList.add("hidden");
  if (removeBtn) removeBtn.classList.add("hidden");
  if (downloadBtn) downloadBtn.classList.add("hidden");

  /* ================= Upload → Preview ================= */
  uploadInput.addEventListener("change", () => {
    const file = uploadInput.files[0];

    if (!file || !file.type.startsWith("image/")) {
      reset();
      return;
    }

    state.file = file;
    state.status = "preview";
    state.resultUrl = null;

    const objectUrl = URL.createObjectURL(file);
    previewImg.src = objectUrl;
    previewImg.classList.remove("hidden");
    placeholder.classList.add("hidden");

    if (removeBtn) removeBtn.classList.remove("hidden");
    if (downloadBtn) downloadBtn.classList.add("hidden");

    tryOnBtn.disabled = false;
  });

  /* ================= Remove Button ================= */
  if (removeBtn) {
    removeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      reset();
    });
  }

  /* ================= Download Button ================= */
  if (downloadBtn) {
    downloadBtn.addEventListener("click", async () => {
      if (!state.resultUrl) return;

      try {
        /* Fetch image as blob to bypass cross-origin restrictions */
        const response = await fetch(state.resultUrl);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = "virtual-tryon-" + Date.now() + ".png";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(blobUrl);
      } catch (err) {
        console.error("Download failed:", err);
        /* Fallback: open in new tab */
        window.open(state.resultUrl, "_blank");
      }
    });
  }

  /* ================= Try On ================= */
  tryOnBtn.addEventListener("click", async () => {
    if (state.isRequestInFlight || !state.file || state.status !== "preview") {
      return;
    }

    state.isRequestInFlight = true;
    state.status = "loading";

    tryOnBtn.disabled = true;
    tryOnBtn.classList.add("loading");
    tryOnBtn.textContent = "Processing\u2026";
    uploadBox.classList.add("loading");

    if (removeBtn) removeBtn.classList.add("hidden");
    if (downloadBtn) downloadBtn.classList.add("hidden");

    try {
      const formData = new FormData();
      formData.append("person_image", state.file);
      formData.append("garment_url", "https:" + window.VIRTUAL_TRYON_CONFIG.garmentUrl);
      formData.append("product_id", window.VIRTUAL_TRYON_CONFIG.productId);
      formData.append("use_full_look", "true");

      const res = await fetch(
        "https://api.nairaa.shop/api/v1/tryon/",
        { method: "POST", body: formData }
      );

      if (!res.ok) throw new Error("Try-On request failed");

      const data = await res.json();
      state.requestId = data.request_id;
      pollForResult();
    } catch (err) {
      console.error(err);
      errorState();
    }
  });

  /* ================= Polling ================= */
  function pollForResult() {
    if (!state.requestId) return;

    const interval = setInterval(async () => {
      try {
        const res = await fetch(
          `https://api.nairaa.shop/api/v1/tryon/${state.requestId}`
        );
        const data = await res.json();

        if (data.status === "completed") {
          clearInterval(interval);
          showResult(data.result_url || data.resultUrl);
        }
        if (data.status === "failed") {
          clearInterval(interval);
          errorState();
        }
      } catch {
        clearInterval(interval);
        errorState();
      }
    }, 3000);
  }

  /* ================= Overlay (Preview Click) ================= */
  previewImg.addEventListener("click", (e) => {
    if (!previewImg.src) return;

    e.preventDefault();
    e.stopPropagation();

    overlayImg.src = previewImg.src;
    overlay.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  });

  if (overlayClose) {
    overlayClose.addEventListener("click", closeOverlay);
  }

  if (overlay) {
    const backdrop = overlay.querySelector(".virtual-tryon-overlay-backdrop");
    if (backdrop) {
      backdrop.addEventListener("click", closeOverlay);
    }
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeOverlay();
  });

  function closeOverlay() {
    if (!overlay) return;
    overlay.classList.add("hidden");
    document.body.style.overflow = "";
    overlayImg.src = "";
  }

  /* ================= Success ================= */
  function showResult(url) {
    state.status = "completed";
    state.isRequestInFlight = false;
    state.resultUrl = url;

    uploadBox.classList.remove("loading");
    tryOnBtn.classList.remove("loading");

    previewImg.src = url;
    previewImg.classList.remove("hidden");

    if (removeBtn) removeBtn.classList.remove("hidden");
    /* Show download button after result is ready */
    if (downloadBtn) downloadBtn.classList.remove("hidden");

    tryOnBtn.textContent = "Try On";
    tryOnBtn.disabled = false;
  }

  /* ================= Error ================= */
  function errorState() {
    state.status = "error";
    state.isRequestInFlight = false;

    uploadBox.classList.remove("loading");
    tryOnBtn.classList.remove("loading");

    if (removeBtn) removeBtn.classList.remove("hidden");

    tryOnBtn.textContent = "Try On";
    tryOnBtn.disabled = false;

    alert("Virtual Try-On failed. Please try again.");
  }

  /* ================= Reset ================= */
  function reset() {
    state.file = null;
    state.status = "idle";
    state.resultUrl = null;

    uploadInput.value = "";
    previewImg.src = "";
    previewImg.classList.add("hidden");

    placeholder.classList.remove("hidden");
    uploadBox.classList.remove("loading");

    if (removeBtn) removeBtn.classList.add("hidden");
    if (downloadBtn) downloadBtn.classList.add("hidden");

    tryOnBtn.disabled = true;
  }
});